<template>
  <footer class="footer footer-segment">
    <div class="container">
      <div class="columns">
        <div class="column copyright">{{ $t("page.copyright", { year: currentYear }) }}</div>
        <div class="column is-half disclaimer">{{ $t("page.disclaimer") }}</div>
        <div class="column imprint">
          <a v-bind:href="$t('links.imprint')" target="_blank">{{ $t('navigation.imprint') }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import fn from '../../services/GlobalService'

export default {
  name: 'footer-segment',
  computed: {
    currentYear () {
      return (new Date()).getFullYear()
    }
  },
  mounted () {}
}
</script>

<style lang="sass">
.footer-segment
  padding-top: 1rem
  padding-bottom: 1rem
  font-size: 0.8rem
  background-color: $white-ter
  z-index: $z-index-content

  .disclaimer
    text-align: left

  .imprint
    text-align: left

  +tablet
    .disclaimer
      text-align: center

    .imprint
      text-align: right
</style>



// WEBPACK FOOTER //
// src/views/segments/FooterSegment.vue